import console from '@common/src/lib/logger'
import { httpsCallable } from 'firebase/functions'
import { CALLBLE_HEADER, CLOUD_FUNCTIONS } from '../../constants/constants'
import { functions, homeFunctions } from '@pulse/firebase/firebaseapi'
import { currentRegion } from '@common/src/config/regions'

/**
 * Functions always called on the home region, whichever region the user works in: admin user/role management
 * (global data) and the dashboard token (dashboards are not regional yet; every region uses the home Superset).
 */
const HOME_ONLY_FUNCTIONS = new Set([
  CLOUD_FUNCTIONS.GET_DASHBOARD_AUTH,
  CLOUD_FUNCTIONS.CREATE_HUB_SUBADMINS,
  CLOUD_FUNCTIONS.UPDATE_HUB_SUBADMINS,
  CLOUD_FUNCTIONS.UPDATE_USER,
  CLOUD_FUNCTIONS.CREATE_HUB_ROLE,
  CLOUD_FUNCTIONS.UPDATE_HUB_ROLE,
  CLOUD_FUNCTIONS.RESEND_INVITE_MAIL,
  CLOUD_FUNCTIONS.FORGOT_PASSWORD,
])

/** Callable + deployed name for the current region, e.g. api-order-updateOrder → api-uk-order-updateOrder. */
const resolveCallable = (functionName) => {
  if (currentRegion.isHome || HOME_ONLY_FUNCTIONS.has(functionName)) {
    return { instance: homeFunctions, name: functionName }
  }
  return { instance: functions, name: functionName.replace(/^api-/, currentRegion.functionPrefix) }
}

export const callCloudFunction = async (functionName, data) => {
  const { instance, name } = resolveCallable(functionName)
  try {
    const callableFunction = httpsCallable(instance, name)
    const res = await callableFunction({
      body: data,
      ...CALLBLE_HEADER,
    })

    if (res?.data?.code === 200) {
      return Promise.resolve(res?.data?.data)
    } else {
      console.log(res)
      return Promise.reject(res?.data)
    }
  } catch (error) {
    console.error(`Error calling ${name}:`, error)
    throw error
  }
}
